import { useQuery } from "@tanstack/react-query";

const useVolunteer = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: volunteerInfo = [],
  } = useQuery({
    queryKey: ["volunteer"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/voluntaryList/${user_id}`
      );
      const data = await res.json();
      // console.log("volunteer data list", data);

      return data;
    },
  });
 
  return [volunteerInfo, isLoading, isError, error, isSuccess, refetch];
};

export default useVolunteer;

// const { refetch, data: patientInfo = [] } = useQuery({
//     queryKey: ["patient"],
//     queryFn: async () => {
//       const res = await fetch("http://192.168.0.84:5000/api/patientInfo");
//       const data = await res.json();
//       return data.result;
//     },

// .then(res => res.json())
// .then(data => setOrders(data));
